"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchToursThunk = void 0;
const axios_1 = __importDefault(require("src/utils/axios"));
const actions_1 = require("./actions");
const actions_2 = require("src/stores/exportedStore/loader/actions");
const fetchToursThunk = () => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/tours/")
        .then((res) => {
        dispatch((0, actions_1.setTours)(res.data.list));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchToursThunk = fetchToursThunk;
